<template>
  <div class="management-page-outer-container">
    <router-view />
    <tickets-list
      v-if="$route.name === 'tickets'"
      :search-from-parent="search"
      @update-search="search = $event"
    />
  </div>
</template>

<script>
import TicketsList from "./TicketsList";

export default {
  name: "TicketsPage",

  components: {
    TicketsList
  },

  data() {
    return {
      search: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Support/TechnicalSupport/Tickets.vue